import * as Types from '../constants/Types';

export const getConfigPHS = (filters) => ({ type: Types.GET_CONFIG_PHS_ACTION, filters });
export const setConfigPHS = (phs) => ({ type: Types.GET_CONFIG_PHS_SUCCESS, phs});

export const updateConfigPHS = (phs) => ({ type: Types.CONFIG_PHS_UPDATE_ACTION, phs });